module.exports = __webpack_public_path__ + "static/media/dog.51d77395.ogg";